// Icons
import percent from '~img/icons/percent-icon.svg'
import rocket from '~img/icons/rocket-icon.svg'
// Donato's
//  Perks:
import facetimecall from '~img/donato/facetime-call.png'
import feature from '~img/donato/feature.png'
import feature2 from '~img/donato/feature2.png'
import merchandising from '~img/donato/merchandising.png'
import playOnline from '~img/donato/play-online.png'
import meet from '~img/donato/meet.png'
import kingsLeague from '~img/donato/kings-league.png'
import socialFollow from '~img/donato/social-follow.png'
import hat from '~img/donato/hat.png'
import nameDisplay from '~img/donato/name-display.png'
// Icon
import donatoAvatar from '~img/donato/avatar.png'
// RDJavi's Perks:
import facetime from '~img/rdjavi/facetime.png'
import social from '~img/rdjavi/social.png'
import personalized from '~img/rdjavi/personalized.png'
import signed from '~img/rdjavi/signed.png'
import gta from '~img/rdjavi/gta.png'
import guest from '~img/rdjavi/guest.png'
// Icon
import javiAvatar from '~img/rdjavi/javi-avatar.png'

const images = {
  percent,
  rocket,
  donatoAvatar,
  javiAvatar,

  facetimecall,
  feature,
  feature2,
  merchandising,
  playOnline,
  meet,
  kingsLeague,
  socialFollow,
  hat,
  nameDisplay,

  facetime,
  social,
  personalized,
  signed,
  gta,
  guest,
}

export const getImg = (perk) => images[perk]
